// versionConfig.js
const VERSION = require('../package.json').version;

export const getVersion = () => VERSION;